import Button from "../../base/Button";

const renderIcon = () => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="13"
        viewBox="0 0 24 13"
    >
        <g fill="none" fillRule="evenodd" stroke="#FFF" strokeWidth="2">
            <path d="M2.25 6.5h20" />
            <path
                strokeLinecap="square"
                d="M17.25 1.5l5 5-5 5M7.25 11.5l-5-5 5-5"
            />
        </g>
    </svg>
);

/**
 * Toolbar button for highlighting a row of lights.
 *
 * @param props - The base toolbar button props.
 * @returns The rendered row button.
 */
const RowButton = (props) => <Button {...props} renderIcon={renderIcon} />;

export default RowButton;
